var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row h1 page-header"},[_vm._v("\n        Event\n    ")]),_vm._v(" "),_c('v-event-info',{attrs:{"event-id":_vm.eventId}}),_vm._v(" "),_c('v-event-available-jobs-list',{attrs:{"event-id":_vm.eventId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }